export const PermissionCompanyFeatures = {
    PUT: "change_companyfeatures",
    VIEW: "view_companyfeatures",
};